export class Comment {
    userComment: string;
    commentDate: Date;
    puid: string;
    status: string;
    details: string;
    fileName: string;
    error: string;
    template: string;
}